import uniqBy from 'lodash/uniqBy';

import { getProductLabel } from '../../campaign-editor/transform-for-rendering';
import RefreshSKUComment from './RefreshSKUComment';
import RefreshSKUForm from './RefreshSKUForm';

export default {
  label: 'Refresh SKU list',
  value: 'Refresh SKU',
  Form: RefreshSKUForm,
  Comment: RefreshSKUComment,
  initialState(campaign, campaignLinesById) {
    const availableProducts = [];
    campaign.campaignLineIds.forEach(lineId => {
      const { product } = campaignLinesById[lineId];
      if (product.supportsHighlightedSKUs) {
        availableProducts.push({
          label: getProductLabel(product),
          value: product.code,
        });
      }
    });

    return {
      highlightedSkus: campaign.highlightedSkus,
      selectedProducts: [],
      availableProducts: uniqBy(availableProducts, 'value'),
    };
  },
  patch(campaign, change) {
    const { highlightedSkus } = change;
    return { highlightedSkus };
  },
};
